<template>
  <div class="container py-5 py-sm-7">
    <a class="d-flex justify-content-center mb-5" href="/">
      <img
        class="zi-2"
        src="@/assets/logos/LogoCATPD.png"
        alt="Image Description"
        style="width: 24rem"
      />
    </a>

    <div class="mx-auto" style="max-width: 30rem">
      <div class="card card-lg mb-5">
        <div class="card-body">
                        
    <form  method="post" class="text-center">
        
        <div class="mb-4">
            <img class="avatar avatar-xxl avatar-4x3" src="@/assets/svg/illustrations/oc-unlock.svg" alt="Image Description" data-hs-theme-appearance="default">
        </div>

        <div class="mb-5">
            <h1 class="display-5">Vérification en 2 étapes</h1>
            <p class="mb-0">Un code de vérification a été envoyé à votre adresse e-mail.</p>
            <p>Entrez le code dans le champ ci-dessous.</p>
        </div>

        <vue3-otp-input
            ref="otpInput"
            input-classes="otp-input shadow-sm"
            :conditionalClass="['one', 'two', 'three', 'four',]"
            separator=" "
            inputType="letter-numeric"
            :num-inputs="4"
            v-model:value="data.otp"
            :should-auto-focus="true"
            :should-focus-order="true"
            :placeholder="[' ', ' ', ' ', ' ',]"
            @update:value="data.otp = $event"
          />
                
        <div class="row gx-2 gx-sm-3">
            <div class="col">
                <div class="mb-4">
                    <input type="text" rank="1" class="form-control form-control-single-number" name="code[]" maxlength="1" autocomplete="off" autocapitalize="off" spellcheck="false" autofocus="">
                </div>
            </div>

            <div class="col">
                <div class="mb-4">
                    <input type="text" rank="2" class="form-control form-control-single-number" name="code[]" placeholder="" aria-label="" maxlength="1" autocomplete="off" autocapitalize="off" spellcheck="false">
                </div>
            </div>

            <div class="col">
                <div class="mb-4">
                    <input type="text" rank="3" class="form-control form-control-single-number" name="code[]" placeholder="" aria-label="" maxlength="1" autocomplete="off" autocapitalize="off" spellcheck="false">
                </div>
            </div>

            <div class="col">
                <div class="mb-4">
                    <input type="text" rank="4" class="form-control form-control-single-number test" name="code[]" placeholder="" aria-label="" maxlength="1" autocomplete="off" autocapitalize="off" spellcheck="false">
                </div>
            </div>

           
        </div>


        <div class="d-grid mb-3">
            <button type="submit" class="btn fab-btn-primary btn-lg">Vérifier mon compte</button>
        </div>

        <div class="text-center">
            <p>Vous ne l'avez pas reçu ? <a>Renvoyer un nouveau code.</a>
            </p>
        </div>
    </form>
                    </div>
      </div>

      <div class="position-relative text-center zi-1">
        <small class="text-cap text-body mb-4">CPD - BENIN</small>
      </div>
    </div>
  </div>
</template>
<script>
// import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import vue3OtpInput from "vue3-otp-input";

export default {
  name: "AuthOtp",
  title: "Connexion",
  components:{
    vue3OtpInput
  },
  data() {
    return {
      data: {
        code: null,
      },
    };
  },
  computed: {
    ...mapFields("auth/otp", {
      isLoading: "isLoading",
      isSuccess:"isSuccess",
      message:"message",
      showMessage:"showMessage",
      item:"item",

    }),
  },

  methods: {
    
  },
};
</script>
<style scoped>
.otp-input {
  width: 50px;
  height: 50px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  text-align: center;
}
/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #e4e4e4;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
